<template>
  <div >
    <b-container>
     <b-card title="Task Overview">
      <b-row>
          <b-col>
            <b-input-group prepend="API-Key">
              <b-form-input v-model="apiKey"></b-form-input>
            </b-input-group>
          </b-col>
      </b-row>
      <br>
      <b-row>
          <b-col>
            <b-input-group prepend="Service">
              <b-form-input v-model="service"></b-form-input>
            </b-input-group>
          </b-col>
          <b-col>
            <b-input-group prepend="State">
              <b-form-input v-model.number="state"></b-form-input>
            </b-input-group>
          </b-col>
          <b-col>
            <b-input-group prepend="Retries">
              <b-form-input v-model.number="retries"></b-form-input>
            </b-input-group>
          </b-col>
      </b-row>
      <br>
      <b-row>
          <b-col>
            <b-input-group prepend="Page">
              <b-form-input v-model.number="page"></b-form-input>
            </b-input-group>
          </b-col>
          <b-col>
            <b-input-group prepend="Limit">
              <b-form-input v-model.number="limit"></b-form-input>
            </b-input-group>
          </b-col>
      </b-row>
      <br>
      <b-row>
          <b-col>
            <b-btn variant="info" @click="loadOverview()">Ok</b-btn>
          </b-col>
          <b-col>
            <b-btn variant="danger" @click="deleteMultiple()">Löschen</b-btn>
          </b-col>
      </b-row>
     </b-card>
      <br>
       <b-row v-if="tasks != undefined">
          <b-col>
            <b-table bordered :items="tasks" :fields="fields">
                <template slot="show_details" slot-scope="row">
                <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
                <b-button size="sm" @click.stop="navigateToTask(row)" class="mr-2">Details
                </b-button>
                </template>
            </b-table>
          </b-col>
      </b-row>
      
    </b-container>
    
     
    <v-dialog/>
  </div>

</template>

<script>
var CryptoJS = require("crypto-js");
export default {
  name: 'TaskOverview',
  data () {
    return {
      apiKey: '',
      service: "",
      state: undefined,
      retries: undefined,
      page: undefined,
      limit: undefined,
      tasks: [],
      fields: ["id", "service", "checkDate", "creationDate", "lockedUntil", "state", "retries", "period", "show_details"]
    }
  },
  created: function () {
    if(this.isBlank(this.apiKey)){
      this.apiKey = this.$route.query.apiKey;
    }
  },
  // methods that implement data logic.
  methods: {
    isBlank: function (str) {
		  if(typeof str === 'boolean' || this.isInt(str)){
          return false;
      } else {
          return (!str || /^\s*$/.test(str))
      }
    },
    isInt: function(value) {
      var x;
      if (isNaN(value)) {
        return false;
      }
      x = parseFloat(value);
      return (x | 0) === x;
    },
    getQueryStringValue: function (key) {
			  return decodeURIComponent(window.location.search.replace(new RegExp('^(?:.*[&\\?]' + encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'))
    },
    loadOverview : function() {
      let view = this;
      let url = '/api/task';
     
      url = this.appendParam("service", this.service, url, '/api/task');
      url = this.appendParam("state", this.state, url, '/api/task');
      url = this.appendParam("retries", this.retries, url, '/api/task');
      url = this.appendParam("page", this.page, url, '/api/task');
      url = this.appendParam("limit", this.limit, url, '/api/task');

      let method = "GET";
      let turl = url.replace(/^.*\/\/[^\/]+/, '');
      let apipath = turl.substring(url.indexOf('/api'));
      let timestamp = (new Date()).getTime();
      
      // create signature
      var signature = [method, apipath, timestamp].join(',');
      
      // hash and base64 encode it
      let hash = CryptoJS.HmacSHA1(signature, this.apiKey).toString(CryptoJS.enc.Base64);

      axios({
        method: 'get',
        headers: {
          'x-api-key': hash,
          'x-api-key-timestamp': timestamp
        },
        url: url
      }).then(response => {
        view.setOverview(response.data);
            
      }).catch(function (error) {
        view.toggleModal('Fehler', '<p>Daten konnten nicht geladen werden.</p>');   
      })
			
    },
    deleteMultiple : function() {
      let view = this;
      let url = '/api/task';
      
      url = this.appendParam("service", this.service, url, '/api/task');
      url = this.appendParam("state", this.state, url, '/api/task');
      url = this.appendParam("retries", this.retries, url, '/api/task');

      let method = "DELETE";
      let turl = url.replace(/^.*\/\/[^\/]+/, '');
      let apipath = turl.substring(url.indexOf('/api'));
      let timestamp = (new Date()).getTime();
      
      // create signature
      var signature = [method, apipath, timestamp].join(',');
      
      // hash and base64 encode it
      let hash = CryptoJS.HmacSHA1(signature, this.apiKey).toString(CryptoJS.enc.Base64);

      axios({
        method: 'delete',
        headers: {
          'x-api-key': hash,
          'x-api-key-timestamp': timestamp
        },
        url: url
      }).then(response => {
        view.toggleModal('Erfolg', '<p>Tasks erfolgreich gelöscht</p>');
        view.loadOverview();
            
      }).catch(function (error) {
        view.toggleModal('Fehler', '<p>Daten konnten nicht geladen werden.</p>');   
      })
			
    },
    appendParam(name, param, url, baseUrl){
      if(!this.isBlank(param)){
        if(url == baseUrl){
          url+="?"+name+"="+param;
        } else {
          url+="&"+name+"="+param;
        }
      }
      return url;
    },
    setOverview: function(data) {
        let overviewA = [];
        var i;
        for (i = 0; i < data.length; i++) { 
            let designItem = {
                id: data[i].id,
                service: data[i].service,
                creationDate: data[i].creationDate,
                checkDate: data[i].checkDate,
                lockedUntil: data[i].lockedUntil,
                state: data[i].state,
                retries: data[i].retries,
                period: data[i].period
            }
            overviewA.push(designItem);
        }
      
        this.tasks = overviewA;
    },
    navigateToTask(row) {
        this.$router.push({ name: 'task', params: { apiKey: this.apiKey, id: row.item.id } })
    },
    toggleModal(title, text) { 
			this.$modal.show('dialog', {
				title: title,
				text: text,
				buttons: [
					{
						title: 'OK',
						handler: () => {
							this.$modal.hide('dialog')
						}
					}
				]
			}) 
		}
  },
  components: {
  },
  computed: {
   
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
